import { z } from 'zod';
import { ArtistIdSchema, IsoDateSchema } from './common.js';
export const ArtistSummaryRowSchema = z.object({
    artistId: ArtistIdSchema,
    artistName: z.string(),
    /**
     * The Pophouse party id (roster database): the key shared with the lake and every other tool.
     * Null until ghost has resolved the artist there.
     */
    partyId: z.string().uuid().nullable(),
    trackCount: z.number().int().nonnegative(),
    /** Luminate locations held in daily_streams for this artist, e.g. ['AA', 'US']. */
    territories: z.array(z.string()),
    lastDate: IsoDateSchema.nullable(),
});
export const ArtistListSchema = z.array(ArtistSummaryRowSchema);
//# sourceMappingURL=artists.js.map